const TYPES = {
    CREATE_INFLUENCER_PROFILE: 'CREATE_INFLUENCER_PROFILE',
    CREATE_INFLUENCER_PROFILE_SUCCESS: 'CREATE_INFLUENCER_PROFILE_SUCCESS',
    CREATE_INFLUENCER_PROFILE_FAILED: 'CREATE_INFLUENCER_PROFILE_FAILED',
    RESEND_EMAIL_VERIFICATION: 'RESEND_EMAIL_VERIFICATION',
    RESEND_EMAIL_VERIFICATION_SUCCESS: 'RESEND_EMAIL_VERIFICATION_SUCCESS',
    RESEND_EMAIL_VERIFICATION_FAILED: 'RESEND_EMAIL_VERIFICATION_FAILED',
    GET_INFLUENCER_PROFILE: 'GET_INFLUENCER_PROFILE',
    GET_ACCOUNT_SOCIAL_LINKS: 'GET_ACCOUNT_SOCIAL_LINKS',
    GET_ACCOUNT_SOCIAL_LINKS_SUCCESS: 'GET_ACCOUNT_SOCIAL_LINKS_SUCCESS',
    GET_ACCOUNT_SOCIAL_LINKS_FAILED: 'GET_ACCOUNT_SOCIAL_LINKS_FAILED'
};

export default {
    TYPES,

    createInfluencerProfile: payload => ({
        type: TYPES.CREATE_INFLUENCER_PROFILE,
        payload
    }),

    createInfluencerProfileSuccess: payload => ({
        type: TYPES.CREATE_INFLUENCER_PROFILE_SUCCESS,
        payload
    }),

    createInfluencerProfileFailed: error => ({
        type: TYPES.CREATE_INFLUENCER_PROFILE_FAILED,
        payload: {error}
    }),

    getInfluencerProfile: () => {},

    resendEmailVerification: () => ({
        type: TYPES.RESEND_EMAIL_VERIFICATION
    }),

    resendEmailVerificationSuccess: payload => ({
        type: TYPES.RESEND_EMAIL_VERIFICATION_SUCCESS,
        payload
    }),

    resendEmailVerificationFailed: error => ({
        type: TYPES.RESEND_EMAIL_VERIFICATION_FAILED,
        payload: {error}
    }),

    getSocialLinks: () => ({
        type: TYPES.GET_ACCOUNT_SOCIAL_LINKS
    }),

    getSocialLinksSuccess: payload => ({
        type: TYPES.GET_ACCOUNT_SOCIAL_LINKS_SUCCESS,
        payload
    }),

    getSocialLinksFailed: error => ({
        type: TYPES.GET_ACCOUNT_SOCIAL_LINKS_FAILED,
        payload: {error}
    })
};
